export default __webpack_public_path__ + "static/media/fastlane_detail1.b648f3cd.jpg";